<template>
  <v-container v-if="user" fluid style="background-color: #f9f9f9">
    <v-row>
      <v-col cols="12">
        <div>
          <!-- Filtros de estado -->
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="busqueda"
                label="Buscar faltante..."
                hide-details
                solo
                dense
                prepend-inner-icon="mdi-magnify"
                class="mr-4"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                label="Filtrar por cliente"
                v-model="clienteSeleccionado"
                :items="clientesUnicos"
                item-text="nombre"
                item-value="id"
                clearable
              ></v-select
            ></v-col>

            <v-col cols="12" md="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div :elevation="0" dark v-bind="attrs" v-on="on">
                    <CrearFaltante />
                  </div>
                </template>
                <span>Crear Faltante</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" class="d-flex flex-wrap">
              <v-btn
                v-for="estado in estados"
                :key="estado.value"
                class="mr-2 mb-2 bordered-button"
                :class="
                  estadoSeleccionado === estado.value
                    ? 'white--text'
                    : 'black--text'
                "
                :color="
                  estadoSeleccionado === estado.value ? '#6A8FB3' : 'white'
                "
                @click="scrollToEstado(estado.value)"
              >
                {{ estado.text }}
              </v-btn>
            </v-col>
          </v-row>

          <v-col cols="12">
            <div v-for="estado in estados" :key="estado.value">
              <h2 class="mb-2">
                {{ estado.text
                }}<v-avatar class="ml-4" color="#6A8FB3" size="32">
                  <span class="white--text font-weight-bold text-body-2">{{
                    cantidadPedidosPorEstado(estado.text)
                  }}</span>
                </v-avatar>
              </h2>
              <v-virtual-scroll
                v-if="faltantesFiltradosPorEstado[estado.text].length > 0"
                :items="faltantesFiltradosPorEstado[estado.text]"
                :item-height="250"
                :height="
                  Math.min(
                    faltantesFiltradosPorEstado[estado.text].length * 250,
                    600,
                  )
                "
                class="mb-4"
              >
                <template v-slot:default="{ item: faltante }">
                  <v-card
                    :id="'Faltante-' + faltante.id"
                    :key="faltante.id"
                    class="mb-2"
                    outlined
                    elevation="4"
                  >
                    <v-card-text
                      class="d-flex justify-space-between align-center"
                    >
                      <div>
                        <div class="d-flex justify-space-between">
                          <h3 class="m-auto">Faltante #{{ faltante.id }}</h3>
                          <v-chip
                            :color="getColorPorEstado(faltante.estado)"
                            v-if="faltante.estado === estado.text"
                            text-color="black"
                            class="mb-2"
                          >
                            {{ faltante.estado }}</v-chip
                          >
                        </div>

                        <div class="subtitle-1 grey--text text--darken-1 mt-2">
                          {{ faltante.codigo_producto }} - {{ faltante.nombre }}
                        </div>
                        <div>Cantidad: {{ faltante.cantidad }}</div>

                        <div class="subtitle-1 grey--text text--darken-1 mt-2">
                          {{ getNombreCliente(faltante.cliente) }}
                        </div>

                        <div
                          class="swipe-track mt-4"
                          tabindex="0"
                          @touchstart="startSwipe($event, faltante)"
                          @touchmove="moveSwipe($event, faltante)"
                          @touchend="endSwipe(faltante)"
                          @mousedown="startSwipe($event, faltante)"
                          @mousemove="moveSwipe($event, faltante)"
                          @mouseup="endSwipe(faltante)"
                          @keydown="handleKey($event, faltante)"
                        >
                          <div
                            class="swipe-fill"
                            :style="{ width: faltante.swipeProgress + '%' }"
                          ></div>
                          <div
                            class="swipe-thumb"
                            :style="{
                              left: faltante.swipeProgress * 2.5 + 'px',
                            }"
                          >
                            <v-icon>mdi-chevron-right</v-icon>
                          </div>
                          <div class="swipe-text">
                            Deslizar para avanzar estado
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <div class="d-flex justify-end align-center mr-2 mb-7">
                          <v-btn
                            icon
                            color="#BA4E38"
                            @click="abrirDialogCancelarFaltante(faltante)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>

                        <v-chip
                          class="mb-5"
                          :color="
                            getDias(faltante.fecha_creacion) > 25
                              ? 'red lighten-4'
                              : getDias(faltante.fecha_creacion) > 15
                              ? 'orange lighten-4'
                              : 'green lighten-4'
                          "
                          variant="elevated"
                          :class="colorDias(getDias(faltante.fecha_creacion))"
                        >
                          {{ getAntiguedad(faltante.fecha_creacion) }}
                        </v-chip>
                        <h3 class="mt-4 mr-2">{{ faltante.laboratorio }}</h3>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </v-virtual-scroll>
              <div
                v-if="faltantesFiltradosPorEstado[estado.text].length === 0"
                class="grey--text mb-4"
              >
                No hay faltantes en {{ estado.text }}.
              </div>
            </div>
          </v-col>
        </div>
        <div v-if="selectedOption === 'areaTrabajo'">
          <AreaTrabajo
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
          />
        </div>
        <div v-if="selectedOption === 'preciosExistencias'">
          <PreciosExistenciasView
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
          />
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="cancelarFaltante" max-width="500">
      <v-card>
        <v-card-title class="">
          ¿Deseas cancelar el faltante #{{ faltanteSeleccionado }}?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="white--text" color="#6A8FB3" @click="CancelarFaltante">
            Si, cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="#6A8FB3"
            @click="cancelarFaltante = false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import AreaTrabajo from "@/components/AreaTrabajo.vue";
import { mapGetters } from "vuex";
import PreciosExistenciasView from "@/views/PreciosExistenciasView.vue";
import CrearFaltante from "@/components/CrearFaltante.vue";

export default {
  data() {
    return {
      busqueda: "",
      clienteSeleccionado: "",
      estadoSeleccionado: "",
      faltantes: [],
      clientes: [],
      estados: [
        {
          text: "Nuevo Faltante",
          value: "nuevo",
        },
        {
          text: "En Inventario",
          value: "inventario",
        },
        {
          text: "En Camino",
          value: "camino",
        },
        {
          text: "Requiere Aclaración",
          value: "aclaracion",
        },
        {
          text: "En Calendario",
          value: "calendario",
        },
      ],
      ordenEstados: [
        {
          text: "Nuevo Faltante",
          value: "nuevo",
        },
        {
          text: "En Inventario",
          value: "inventario",
        },
        {
          text: "En Camino",
          value: "camino",
        },
        {
          text: "Requiere Aclaración",
          value: "aclaracion",
        },
        {
          text: "En Calendario",
          value: "calendario",
        },
      ],
      selectedOption: "",
      productos: [],
      usuarios: [],
      permisoAreaTrabajo: false,
      cancelarFaltante: false,
      faltanteSeleccionado: null,
    };
  },
  methods: {
    abrirDialogCancelarFaltante(faltante) {
      this.faltanteSeleccionado = faltante.id;
      this.cancelarFaltante = true;
    },

    async CancelarFaltante() {
      try {
        await axios.post(
          `/faltantes/modificar_faltante?id_faltante=${this.faltanteSeleccionado}&nuevo_estado=Cancelado`,
        );
        //console.log(response.data);
        this.cancelarFaltante = false;
        alert("Faltante Cancelado correctamente.");
      } catch (error) {
        console.error(error);
        alert(error.response.data.detail);
      }
    },

    async getPermisoAgregarPrepedido() {
      try {
        const response = await axios.get(`/usuarios/yo`);
        // Separar el string en partes usando espacio como delimitador
        const permisos = response.data.permisos.split(" ");

        // Definir los sufijos buscados
        const sufijosBuscados = [
          ":pedidos:crear",
          "pedidos:crear_ageno",
          ":ADMINISTRADOR",
        ];

        // Comprobar si alguna parte termina con alguno de los sufijos buscados
        const algunaParteTerminaConSufijo = permisos.some((parte) =>
          sufijosBuscados.some((sufijo) => parte.endsWith(sufijo)),
        );

        // algunaParteTerminaConSufijo será true si alguna parte termina con "_existencia", de lo contrario, será false
        // console.log(algunaParteTerminaConSufijo);
        this.permisoAreaTrabajo = algunaParteTerminaConSufijo;
      } catch (error) {
        console.error(error);
      }
    },

    async getProductos() {
      try {
        const response = await axios.get(`/productos/get_lista`);
        this.productos = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
      }
    },

    getNombreUsuario(usuarioId) {
      const usuarioEncontrado = this.usuarios.find(
        (usuario) => usuario.id === usuarioId,
      );
      if (usuarioEncontrado) {
        return usuarioEncontrado.nombre;
      }
      return "";
    },

    async getFaltantes() {
      try {
        const response = await axios.get(`/faltantes/get_abiertos`);
        const data = response.data;
        this.faltantes = data.reduce((acc, sucursal) => {
          const faltantesConSucursal = sucursal.faltantes.map((f) => ({
            ...f,
            sucursal: sucursal.sucursal,
            expanded: false,
            swipeProgress: 0,
            isDragging: false,
            startX: 0,
          }));
          return acc.concat(faltantesConSucursal);
        }, []); // Inicializar el acumulador con un array vacío
        //console.log(this.faltantes);
      } catch (error) {
        console.error(error);
      }
    },

    async getClientes() {
      try {
        const response = await axios.get(`/clientes/get_nombres`);
        this.clientes = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    getNombreCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId,
      );
      if (clienteEncontrado) {
        return clienteEncontrado.razon_social + " ";
      }
      return "";
    },

    formatoMoneda(valor) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(valor);
    },
    getDias(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      return Math.floor(diffMs / (1000 * 60 * 60 * 24));
    },
    getAntiguedad(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHrs = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      if (diffDays > 0) {
        return `${diffDays} día${diffDays > 1 ? "s" : ""}`;
      } else if (diffHrs > 0) {
        return `${diffHrs} hora${diffHrs > 1 ? "s" : ""}`;
      } else if (diffMins > 0) {
        return `${diffMins} minuto${diffMins > 1 ? "s" : ""}`;
      } else {
        return `menos de un minuto`;
      }
    },

    colorDias(dias) {
      if (dias > 25) return "red--text";
      if (dias > 15) return "orange--text";
      return "green--text";
    },

    getColorPorEstado(estado) {
      switch (estado) {
        case "Nuevo Faltante":
          return "#C8E6C9";
        case "requiere_aclaracion":
          return "#FFF9C4";
        case "en_calendario":
          return "#DCEDC8";
        case "en_inventario":
          return "#FFECB3";
        case "preparacion_en_almacen":
          return "#FFE0B2";
        case "preparado":
          return "#FFCCBC";
        case "en_ruta_de_entrega":
          return "#FFCCBC";
      }
    },

    async avanzarEstado(faltante) {
      try {
        await axios.post(
          `/faltantes/modificar_faltante?id_faltante=${faltante.id}&nuevo_estado=Facturado`,
        );
        //console.log(response.data);
        faltante.isDragging = false;
        faltante.startX = 0;
        faltante.swipeProgress = 0;
        alert("Avanzado correctamente a facturado.");
        this.getFaltantes();
      } catch (error) {
        console.error(error);
        alert(
          "Error al avanzar estado: " + error.response?.data?.detail ||
            error.message,
        );
      }
    },

    startSwipe(e, faltante) {
      faltante.isDragging = true;
      faltante.startX = e.touches ? e.touches[0].clientX : e.clientX;
      e.preventDefault();
    },

    moveSwipe(e, faltante) {
      if (!faltante.isDragging) return;
      const currentX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = currentX - faltante.startX;
      const maxWidth = 300; // Ancho aproximado del track, ajustar si necesario
      faltante.swipeProgress = Math.min(
        100,
        Math.max(0, (deltaX / maxWidth) * 100),
      );
      e.preventDefault();
    },

    endSwipe(faltante) {
      if (!faltante.isDragging) return;
      faltante.isDragging = false;
      if (faltante.swipeProgress >= 100) {
        this.avanzarEstado(faltante);
      } else {
        faltante.swipeProgress = 0;
      }
    },

    handleKey(e, faltante) {
      if (e.key === "ArrowRight") {
        faltante.swipeProgress = Math.min(100, faltante.swipeProgress + 10);
      } else if (e.key === "ArrowLeft") {
        faltante.swipeProgress = Math.max(0, faltante.swipeProgress - 10);
      } else if (e.key === "Enter" && faltante.swipeProgress >= 100) {
        this.avanzarEstado(faltante);
      }
    },
    scrollToEstado(estadoValue) {
      this.$nextTick(() => {
        const estadoIndex = this.estados.findIndex(
          (e) => e.value === estadoValue,
        );
        if (estadoIndex !== -1) {
          const estadoElements = this.$el.querySelectorAll("h2");
          if (estadoElements[estadoIndex]) {
            estadoElements[estadoIndex].scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    },
    cantidadPedidosPorEstado(estado) {
      return this.faltantesFiltradosPorEstado[estado]
        ? this.faltantesFiltradosPorEstado[estado].length
        : 0;
    },
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["currentUser"]),

    faltantesFiltradosPorEstado() {
      const agrupados = {};
      for (const estado of this.estados) {
        agrupados[estado.text] = this.faltantes.filter(
          (p) =>
            p.estado === estado.text &&
            (!this.clienteSeleccionado ||
              p.cliente === this.clienteSeleccionado) &&
            (this.getNombreCliente(p.cliente)
              .toLowerCase()
              .includes(this.busqueda.toLowerCase()) ||
              p.id.toString().includes(this.busqueda) ||
              this.getAntiguedad(p.fecha_creacion).includes(this.busqueda)),
        );
      }
      return agrupados;
    },

    clientesUnicos() {
      const clientesSet = new Set();
      this.faltantes.forEach((f) => {
        if (f.cliente) clientesSet.add(f.cliente);
      });
      return Array.from(clientesSet)
        .map((id) => ({ id, nombre: this.getNombreCliente(id) }))
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
  },
  created() {
    this.getUsuarios();
    this.getClientes();
    this.getProductos();
    this.getPermisoAgregarPrepedido();
  },

  mounted() {
    this.getFaltantes();
    this.getClientes();
  },

  beforeDestroy() {},
  components: {
    AreaTrabajo,
    PreciosExistenciasView,
    CrearFaltante,
  },
};
</script>

<style scoped>
.bordered-button {
  border: 1px solid #ccc;
}

.swipe-track {
  position: relative;
  height: 50px;
  width: 300px;
  background: #ddd;
  border-radius: 25px;
  overflow: hidden;
  display: flex;
  align-items: center;
  /* Optimizaciones agresivas para tablets */
  touch-action: pan-y;
  will-change: transform;
  transform: translateZ(0); /* Forzar aceleración de hardware */
  contain: layout style paint; /* Aislamiento de renderizado */
  isolation: isolate; /* Crear nueva capa de apilamiento */
}

.swipe-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(
    to right,
    #6a8fb3,
    #1976d2 30%,
    #1976d2 70%,
    #6a8fb3 100%
  );
  transition: width 120ms linear;
  border-radius: 25px 0 0 25px;
  z-index: 1;
}

.swipe-thumb {
  position: absolute;
  top: 2px;
  width: 50px;
  height: 46px;
  border-radius: 23px;
  background: #1976d2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 2;
  /* Optimizaciones agresivas para tablets */
  touch-action: pan-y;
  will-change: transform;
  transform: translateZ(0); /* Forzar aceleración de hardware */
  contain: layout style paint; /* Aislamiento de renderizado */
  backface-visibility: hidden; /* Optimización adicional */
}

.swipe-thumb.dragging {
  transition: none !important;
  transform: none !important; /* Desactivar transform CSS, usamos JS directo */
}

.swipe-track.dragging * {
  transition: none !important; /* Desactivar todas las transiciones durante drag */
}

.swipe-text {
  width: 100%;
  text-align: center;
  position: absolute;
  font-weight: bold;
  color: #555;
  z-index: 0;
  pointer-events: none;
}

.enabled-button {
  background-color: #6a8fb3 !important;
  color: white !important;
}

.disabled-button {
  background-color: white !important;
  color: black !important;
}
.dialog-comentarios {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(10px);
  border-radius: 15px; /* Bordes redondeados */
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.background-circle {
  background-color: #e0e0e0;
  border-radius: 20px;
  padding: 5px 15px;
  display: inline-block;
  max-width: 80%;
}
.comentario-no-leido {
  background: #e3f2fd;
  border-left: 4px solid #1976d2;
  border-radius: 8px;
  padding: 8px;
}

.v-card {
  scroll-margin-top: 80px;
}

.btn-historial {
  background-color: rgba(106, 143, 179, 0.8) !important;
}

.chip-estado {
  background-color: rgba(200, 230, 201, 0.8) !important;
}
</style>
